(() => {
  const KEY = 'bitco:vat-display';
  const apply = (mode, persist) => {
    document.body.dataset.vatDisplay = mode;
    if (persist) try { localStorage.setItem(KEY, mode); } catch (e) {}
    document.querySelectorAll('[data-vat-toggle] button[data-mode]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.mode === mode));
    });
    document.dispatchEvent(new CustomEvent('bitco:vat-change', { detail: { mode } }));
  };
  const ROLE_KEY = 'bitco:vat-default-seen';
  const init = () => {
    let stored = null;
    let seenDefault = null;
    try {
      stored = localStorage.getItem(KEY);
      seenDefault = localStorage.getItem(ROLE_KEY);
    } catch (e) {}
    const fallback = document.body.dataset.vatDefault === 'excl' ? 'excl' : 'incl';
    // A preference saved under a different customer state is stale — e.g.
    // toggled to incl while anonymous, then logged in as wholesale (default
    // excl). The new server-derived default wins over the old preference.
    if (seenDefault !== fallback) {
      stored = null;
      try {
        localStorage.removeItem(KEY);
        localStorage.setItem(ROLE_KEY, fallback);
      } catch (e) {}
    }
    apply(stored === 'excl' || stored === 'incl' ? stored : fallback, false);
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vat-toggle] button[data-mode]');
      if (btn) apply(btn.dataset.mode, true);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
